import { useEffect, useState } from 'react'
import VerifyOTP from '../../components/login/VerifyOTP';
import { useDispatch } from 'react-redux';
import { login } from '../../redux-stores/slices/authSlice';
import { AppDispatch, getIntendedPath, RootState } from '../../redux-stores/store';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MobileView from '../../layouts/MobileView/MobileView';
import { fetchInfluencer } from '../../redux-stores/slices/influencerSlice';
import { INIT_IG_AUTH_ROUTE } from '../../constants/constants';
import { Link } from 'react-router-dom';
import { generateLoginOTP, verifyOTP } from '../../services/api/auth';
import AuthLayout from '../../layouts/AuthLayout';
import { getErrorMessage, isValidMobileNumber } from '../../utils/helpers';
import { analyticsSetUser } from "../../lib/analytics";
import { toast } from 'react-toastify';

const Login: React.FC = () => {

    const [otpSent, setOTPSent] = useState(false);
    const [number, setNumber] = useState('');
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { isAuthenticated } = useSelector((state: RootState) => state.auth);
    const connectionRequired = useSelector((state: RootState) => state.influencer.connectionRequired);
    const igAuthWall = useSelector((state: RootState) => state.auth.configurations?.ig_auth_wall === 'y')
    const isVerified = useSelector((state: RootState) => state.influencer.influencer?.verification?.is_verified);

    const [mode, setMode] = useState<string|undefined>('');

    const [OTPSending, setOTPSending] = useState(false);

    const fetchUser = async (token: string) => {
        await dispatch(fetchInfluencer(token));
        await dispatch(login(token));
    }

    useEffect(() => {
        if (isAuthenticated) {
            const redirectURL = (connectionRequired && igAuthWall && !isVerified) ?  INIT_IG_AUTH_ROUTE : getIntendedPath();
            navigate(redirectURL);
        }
    }, [isAuthenticated, connectionRequired, navigate])

    const sendOTP = async () => {
    
            if (!isValidMobileNumber(number)) return;
    
            try {
                setOTPSending(true);
                const res = await generateLoginOTP({ mode: 'mobile', username: number });
                if (res.status) {
                    setMode(res.mode);
                    setOTPSent(true)
                }
            } catch (error) {
                console.error(error);
                toast.error(getErrorMessage(error))
            } finally {
                setOTPSending(false);
            }
    
        }
    
        const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === "Enter") {
                event.preventDefault();
                sendOTP()
            }
        };

    return (
        <MobileView>
            <AuthLayout>
{
                    !otpSent ? (
                        <div className="position-relative h-100">
                            <h4 className="pop w-100 text-center auth-heading">Login To Your Account</h4>
                            <div className="auth-form">
                                <div className="auth-form-input-wrapper">
                                    <span>+91</span>
                                    <input type="tel"
                                        className="w-100"
                                        id="form1" placeholder="Enter WhatsApp Number"
                                        value={number}
                                        onChange={e => setNumber(e.target.value)}
                                        autoComplete="off"
                                        maxLength={10}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>
                                <button
                                    onClick={sendOTP}
                                    disabled={OTPSending || (!number || number.length < 10)} className="new-ui-btn">Continue</button>
                            </div>
                            <div className="auth-nav-content">
                                <span>Not a Member yet? <Link to="/register" className="link-primary">Sign up</Link></span>
                            </div>
                           
                        </div>
                    ) : (
                        <div className="position-relative h-100">
                            <VerifyOTP mode={mode} number={number} verifyOTP={verifyOTP} onSuccess={(user) => fetchUser(user.token)} onBackButtonClick={() => setOTPSent(false)} />
                        </div>
                    )
                }
            </AuthLayout>
        </MobileView>

    )
}

export default Login